"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
class APIModule {
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    async getAddressFromCEP(cep) {
        cep = cep.replace("-", "");
        const { data } = await axios_1.default.get(`https://viacep.com.br/ws/${cep}/json/`);
        return data;
    }
    async getCompanyDataFromCNPJ(cnpj) {
        cnpj = cnpj
            .replace(/\_/g, "")
            .replace(/\./g, "")
            .replace(/\-/g, "")
            .replace(/\//g, "");
        const { data } = await this.axiosInstance.get(`/api/v2/utils/cnpj/${cnpj}/`);
        return data;
    }
}
exports.default = APIModule;
//# sourceMappingURL=api.js.map